import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideModal,
  createProveedor,
  updateProveedor,
  deleteProveedor,
} from "../../store/actions/proveedores";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { ErrorMessage } from "../../components/ErrorMessage";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import InputField from "../../components/InputField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useStyles } from '../../lib/styles/nuevoStyles';

import {
  proveedoresForm,
  defaultVal,
  validation,
} from "../../lib/forms/proveedoresForm";

export const NuevoProveedor = () => {
  const showModal = useSelector((state) => state.proveedores.showModal);
  const page = useSelector((state) => state.proveedores.page);
  const pageSize = useSelector((state) => state.proveedores.pageSize);
  const dataBuscar = useSelector((state) => state.proveedores.dataBuscar);
  const proveedor = useSelector((state) => state.proveedores.proveedor);
  const editMode = useSelector((state) => state.proveedores.editMode);
  const isLoading = useSelector((state) => state.proveedores.isLoading);
  const error = useSelector((state) => state.proveedores.error);
  const dispatch = useDispatch();

  const proveedorAjusted = {
    ...proveedor,
    particular: proveedor.particular ? "si" : "no",
  };

  const classes = useStyles();

  const formModel = proveedoresForm();
  const defaultValues = defaultVal();
  const validationSchema = validation();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: editMode ? proveedorAjusted : defaultValues,
  });

  const onDelete = () => {
    const id = proveedor.id;
    if (
      window.confirm(
        `Esta seguro que desea borrar el proveedor ${proveedor.nombre}?`
      )
    ) {
      dispatch(deleteProveedor({ id, page, pageSize, dataBuscar }));
    }
  };

  const onSubmit = (values) => {
    const data = {
      ...values,
      particular: values.particular === "si",
    };
    const id = proveedor.id;
    if (editMode) {
      dispatch(updateProveedor({ id, data, page, pageSize, dataBuscar }));
    } else {
      dispatch(createProveedor({ data, pageSize }));
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          dispatch(hideModal());
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          {editMode ? "Editar Proveedor" : "Agregar Nuevo Proveedor"}
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <Grid container spacing={2}>
              {formModel.map((input) => (
                <Grid item key={input.props.name} md={input.width} xs={12}>
                  <InputField
                    {...input.props}
                    control={control}
                    errors={errors}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
          {error && <ErrorMessage module="proveedores" />}
        </DialogContent>
        <DialogActions>
          {editMode && (
            <Button onClick={onDelete} className={classes.warning}>
              Borrar Proveedor
            </Button>
          )}
          <Button
            onClick={() => dispatch(hideModal())}
            color="primary"
            tabIndex={-1}
          >
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {editMode ? "Editar" : "Capturar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
